import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'
// import { Options, LabelType } from '@angular-slider/ngx-slider';
import { Web3Service } from 'app/services/web3/web3.service';
import { environment } from 'environments/environment';

declare const analytics

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizardComponent implements OnInit {

  public specialityLabel
  public typeLabel
  public currentIndex
  public minValuePrice
  public maxValuePrice
  // public minValueMain: number = 0;
  // public maxValueMain: number = 10000;
  rangeValue: number[] = [0, 10000];
  // public minValueSecond: number = 0;
  // public maxValueSecond: number = 10000;
  rangeSecondValue: number[] = [0, 10000]
  public elementsArrayMain: any = []
  public elementsArraySecond: any = []
  public specialityArray: any = []
  public openFilter
  public parsedKryptomon: any = []
  public parsingIndex
  public parsedSuccess
  public lifeStageArray: any = []
  public lifeStageLabel
  public typeLabelSecond
  public priceLabel
  public tierArray: any = [];
  public tierFilter
  public mainPowerFilter
  public secondPowerFilter
  public isOnSaleFilter
  public isOnBreedFilter
  public sortingArray = [false, false]
  public selectedPriceSorting
  public selectedTimeSorting
  public searchId
  public totalResult
  public scrollCount = 1
  public loadInfinite
  public showSearchIcon
  public posY
  isAuraFilter:boolean = false;
  /*public optionsPrice: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return "<b>Min price:</b> $" + value;
        case LabelType.High:
          return "<b>Max price:</b> $" + value;
        default:
          return "$" + value;
      }
    }    
  };*/


  // public optionsTalent: Options = {
  //   floor: 0,
  //   ceil: 10000,
  //   translate: (value: number, label: LabelType): string => {
  //     switch (label) {
  //       case LabelType.Low:
  //         return "" + value;
  //       case LabelType.High:
  //         return "" + value;
  //       default:
  //         return "" + value;
  //     }
  //   }
  // };
  constructor(
    private zone: NgZone,
    private http: HttpClient,
    private router: Router,
    private ref: ChangeDetectorRef,
    private web3Service: Web3Service

  ) {
    this.currentIndex = 0;
    this.elementsArrayMain = [{ selected: false, type: "Fire", img: "./assets/img/icons/fire.svg" }, { selected: false, type: "Air", img: "./assets/img/icons/air.svg" }, { selected: false, type: "Grass", img: "./assets/img/icons/grass.svg" }, { selected: false, type: "Ice", img: "./assets/img/icons/ice.svg" }, { selected: false, type: "Electro", img: "./assets/img/icons/electro.svg" }, { selected: false, type: "Ghost", img: "./assets/img/icons/ghost.svg" }, { selected: false, type: "Ground", img: "./assets/img/icons/ground.svg" }, { selected: false, type: "Water", img: "./assets/img/icons/water.svg" },]
    this.elementsArraySecond = [{ selected: false, type: "Fire", img: "./assets/img/icons/fire.svg" }, { selected: false, type: "Air", img: "./assets/img/icons/air.svg" }, { selected: false, type: "Grass", img: "./assets/img/icons/grass.svg" }, { selected: false, type: "Ice", img: "./assets/img/icons/ice.svg" }, { selected: false, type: "Electro", img: "./assets/img/icons/electro.svg" }, { selected: false, type: "Ghost", img: "./assets/img/icons/ghost.svg" }, { selected: false, type: "Ground", img: "./assets/img/icons/ground.svg" }, { selected: false, type: "Water", img: "./assets/img/icons/water.svg" },]
    this.specialityArray = [{ type: 'Attack', selected: false }, { type: 'Balance', selected: false }, { type: 'Defense', selected: false }]
    this.lifeStageArray = [{ type: 'Egg', selected: false, value: 0 }, { type: 'Baby', selected: false, value: 1 }, { type: 'Junior', selected: false, value: 2 }]
    this.tierArray = [{type:'Rookie', selected:false, value:1.5},{type:'Veteran', selected:false, value:2.5},{type:'Elite', selected:false, value:4},{type:'Hero', selected:false, value:5}]
    this.openFilter = false;
    this.typeLabel = ""
    this.specialityLabel = ""
    this.lifeStageLabel = ""
    this.typeLabelSecond = ""
    this.priceLabel = ""
    this.tierFilter = ""
    this.parsingIndex = 0;
    this.parsedSuccess = false;
    this.isOnSaleFilter = false;
    this.isOnBreedFilter = false;
    this.selectedPriceSorting = "cheapest"
    this.selectedTimeSorting = "newest"
    this.loadInfinite = false;
    this.showSearchIcon = true;
    /*this.http.get("https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?first=1&skip=0&sortBy=dearest&category=kryptomon&isOnSale=true&section=all").subscribe((item:any)=>{
      this.maxValuePrice = 10000//item.data.order.price
    })*/

    this.isOnSaleFilter = true;
    this.loadKryptomon(environment.nftServer + "v1/nfts?first=100&skip=0&sortBy=newest&category=kryptomon&isOnSale=true&section=all");


  }

  ngOnInit(): void {
  }

  onScroll() {
    console.log('scroll_end')
    if (this.showSearchIcon && !this.loadInfinite) {
      this.posY = window.scrollY
      this.urlBuilding(true)
    }
  }

  /*onPaste($event){
    //console.log($event)
    //console.log(this.searchId)
  }*/

  /*searchById($event){
    //console.log($event)
    //console.log(this.searchId)
    this.showSearchIcon = false;
    this.parsedKryptomon = [];
      for(let i = 0; i<this.searchId.length;i++){
        let url = "https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?first=24&skip=0&sortBy=newest&category=kryptomon&search="+this.searchId[i].value+"&section=all&priceToken=all"
        this.loadKryptomon(url, true);
      }
  }*/

  searchById($event) {
    console.log($event)
    console.log(this.searchId)
    this.showSearchIcon = false;
    if (this.searchId.length == 1) {
      this.parsedKryptomon = []
      console.log('qui di nuovo')
      let url = environment.nftServer + "v1/nfts?first=24&skip=0&sortBy=newest&category=kryptomon&search=" + this.searchId[0].value + "&section=all&priceToken=all"
      this.loadKryptomonAttach(url);
    } else {
      setTimeout(() => {
        let url = environment.nftServer + "v1/nfts?first=24&skip=0&sortBy=newest&category=kryptomon&search=" + $event.value + "&section=all&priceToken=all"
        this.loadKryptomonAttach(url);
      }, 100)
    }

    analytics.track('Filter used', {
      section: 'search', // toggle, filter, search
      value: 'search bar', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: $event.value// input of query/filter)             
    });
  }

  cleanSearchId($event) {
    if (this.searchId.length == 0) {
      this.showSearchIcon = true;
      this.urlBuilding(false)
    } else {
      for (let i = 0; i < this.parsedKryptomon.length; i++) {
        if ($event.value == this.parsedKryptomon[i].data.tokenId) {
          this.parsedKryptomon.splice(i, 1)
        }
      }
    }
  }

  sortByTime(sorting) {
    this.selectedTimeSorting = sorting;
    this.sortingArray[1] = false;
    this.urlBuilding(false)
    analytics.track('Filter used', {
      section: 'sort', // toggle, filter, search
      value: 'sort-time', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: sorting// input of query/filter)             
    });
  }

  sortByPrice(sorting) {
    if (sorting == 'cheapest') {
      this.parsedKryptomon.sort(this.sortingRule(true));
    } else {
      this.parsedKryptomon.sort(this.sortingRule(false));
    }
    this.selectedPriceSorting = sorting;
    this.sortingArray[0] = false;
    analytics.track('Filter used', {
      section: 'sort', // toggle, filter, search
      value: 'sort-price', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: sorting// input of query/filter)             
    });
  }

  sortingRule(ascending) {
    return function (a, b) {


      // nulls sort after anything else
      if (a.data.order === null) {
        return 1;
      }
      if (b.data.order === null) {
        return -1;
      }

      // equal items sort equally
      if (a.data.order.priceUSD === b.data.order.priceUSD) {
        return 0;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.data.order.priceUSD < b.data.order.priceUSD ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.data.order.priceUSD < b.data.order.priceUSD ? 1 : -1;
    };
  }

  toggleSortingBox(index) {
    for (let i = 0; i < this.sortingArray.length; i++) {
      if (i == index && !this.sortingArray[index]) {
        this.sortingArray[i] = true;
      } else {
        this.sortingArray[i] = false;
      }
    }
  }

  selectElementMain(element, index) {
    this.typeLabel = "";
    if (this.elementsArrayMain[index].selected) {
      this.elementsArrayMain[index].selected = false;
    } else {
      this.elementsArrayMain[index].selected = true;
    }

    for (let i = 0; i < this.elementsArrayMain.length; i++) {
      if (this.elementsArrayMain[i].selected) {
        if (this.typeLabel !== "") {
          this.typeLabel = this.typeLabel + '_' + this.elementsArrayMain[i].type
        } else {
          this.typeLabel = this.elementsArrayMain[i].type
        }
      }
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'main elemental families', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.typeLabel// input of query/filter)             
    });
    //console.log(this.typeLabel)
    this.urlBuilding(false)
  }

  selectElementSecond(element, index) {
    this.typeLabelSecond = "";
    if (this.elementsArraySecond[index].selected) {
      this.elementsArraySecond[index].selected = false;
    } else {
      this.elementsArraySecond[index].selected = true;
    }

    for (let i = 0; i < this.elementsArraySecond.length; i++) {
      if (this.elementsArraySecond[i].selected) {
        if (this.typeLabelSecond !== "") {
          this.typeLabelSecond = this.typeLabelSecond + '_' + this.elementsArraySecond[i].type
        } else {
          this.typeLabelSecond = this.elementsArraySecond[i].type
        }
      }
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'second elemental families', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.typeLabelSecond// input of query/filter)             
    });
    //console.log(this.typeLabelSecond)
    this.urlBuilding(false)
  }

  urlBuilding(isScroll, amount = 100) {

    this.searchId = null
    this.showSearchIcon = true;

    var isonsale: any = ""
    if (this.isOnSaleFilter) {
      isonsale = true;
    }

    var isonbreed: any = "";
    if (this.isOnBreedFilter) {
      isonbreed = true;
    }

    var isaura: any = "";
    if (this.isAuraFilter) {
      isaura = 1;
    }


    if (isScroll) {

      let skip = 100 * this.scrollCount
      this.scrollCount++
      let first = amount
      //console.log(skip)
      //console.log(first)
      //console.log(this.scrollCount)
      var sortBy = this.selectedTimeSorting.replace(" ", "_")
      let queryString = "first=" + first + "&skip=" + skip + "&sortBy=" + sortBy + "&category=kryptomon&isOnSale=" + isonsale + "&section=all&kryptomonStatus=" + this.lifeStageLabel + "&price=" + this.priceLabel + "&secondElemTypes=" + this.typeLabelSecond + "&elemTypes=" + this.typeLabel + "&specialties=" + this.specialityLabel + "&isInBreedingCentre=" + isonbreed + "&unfreezable="+isaura
      const params = new URLSearchParams(queryString);
      [...params.entries()].forEach(([key, value]) => {
        if (!value) {
          params.delete(key);
        }
      });
      const url = environment.nftServer + "v1/nfts?" + String(params);
      //console.log(url);
      this.infiniteLoadKryptomon(url)
    } else {
      this.scrollCount = 1;
      var sortBy = this.selectedTimeSorting.replace(" ", "_")
      let queryString = "first=100&skip=0&sortBy=" + sortBy + "&category=kryptomon&isOnSale=" + isonsale + "&section=all&kryptomonStatus=" + this.lifeStageLabel + "&price=" + this.priceLabel + "&secondElemTypes=" + this.typeLabelSecond + "&elemTypes=" + this.typeLabel + "&specialties=" + this.specialityLabel + "&isInBreedingCentre=" + isonbreed + "&unfreezable="+isaura
      const params = new URLSearchParams(queryString);
      [...params.entries()].forEach(([key, value]) => {
        if (!value) {
          params.delete(key);
        }
      });
      const url = environment.nftServer + "v1/nfts?" + String(params);
      //console.log(url);
      this.loadKryptomon(url, true)
    }

  }

  toggleSale() {
    //console.log(this.isOnSaleFilter)   
    setTimeout(() => {
      this.isOnSaleFilter = !this.isOnSaleFilter
      this.urlBuilding(false);
      analytics.track('Filter used', {
        section: 'toggle', // toggle, filter, search
        value: 'on sale', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
        input: this.isOnSaleFilter// input of query/filter)             
      });
    }, 100)
  }
  toggleAura() {
    //console.log(this.isOnSaleFilter)   
    setTimeout(() => {
      this.isAuraFilter = !this.isAuraFilter
      this.urlBuilding(false);
      analytics.track('Filter used', {
        section: 'toggle', // toggle, filter, search
        value: 'on sale', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
        input: this.isOnSaleFilter// input of query/filter)             
      });
    }, 100)
  }
  toggleBreed() {
    setTimeout(() => {
      this.isOnBreedFilter = !this.isOnBreedFilter
      this.urlBuilding(false);
      analytics.track('Filter used', {
        section: 'toggle', // toggle, filter, search
        value: 'breedable', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
        input: this.isOnBreedFilter// input of query/filter)             
      });
    }, 100)
  }


  selectSpeciality(index) {
    this.specialityLabel = "";
    if (this.specialityArray[index].selected) {
      this.specialityArray[index].selected = false;
    } else {
      this.specialityArray[index].selected = true;
    }

    for (let i = 0; i < this.specialityArray.length; i++) {
      if (this.specialityArray[i].selected) {
        if (this.specialityLabel !== "") {
          this.specialityLabel = this.specialityLabel + '_' + this.specialityArray[i].type
        } else {
          this.specialityLabel = this.specialityArray[i].type
        }
      }
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'speciality', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.specialityLabel// input of query/filter)             
    });
    //console.log(this.specialityLabel)
    this.urlBuilding(false)
  }

  selectLifeStage(index) {
    this.lifeStageLabel = "";
    if (this.lifeStageArray[index].selected) {
      this.lifeStageArray[index].selected = false;
    } else {
      this.lifeStageArray[index].selected = true;
    }

    for (let i = 0; i < this.lifeStageArray.length; i++) {
      if (this.lifeStageArray[i].selected) {
        if (this.lifeStageLabel !== "") {
          this.lifeStageLabel = this.lifeStageLabel + '_' + this.lifeStageArray[i].value
        } else {
          this.lifeStageLabel = this.lifeStageArray[i].value
        }
      }
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'life stage', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.lifeStageLabel// input of query/filter)             
    });
    //console.log(this.lifeStageLabel)
    this.urlBuilding(false)
  }

  selectTier(index) {
    //this.tierFilter = "";
    this.tierFilter = "";
    if (this.tierArray[index].selected) {
      this.tierArray[index].selected = false;
    } else {
      this.tierArray[index].selected = true;
      this.urlBuilding(true, 500)
    }

    for (let i = 0; i < this.tierArray.length; i++) {
      if (this.tierArray[i].selected) {
        if (this.tierFilter !== "") {
          this.tierFilter = this.tierFilter + '_' + this.tierArray[i].type
        } else {
          this.tierFilter = this.tierArray[i].type
        }
      }
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'rank', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.tierFilter// input of query/filter)             
    });

    //console.log(this.tierFilter)
  }

  resizeByMain(event) {
    this.mainPowerFilter = { minVal: event.values[0], maxVal: event.values[1] }
    // console.log(this.mainPowerFilter);
    if (this.parsedKryptomon.length < this.totalResult) {
      this.urlBuilding(true)
    }
    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'main total power', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: event.values[0] + "_" + event.values[1]// input of query/filter)             
    });
  }

  reziseByMainNumber(event) {
    this.resizeByMain({
      values: this.rangeValue
    });
  }

  resizeBySecond(event) {
    this.secondPowerFilter = { minVal: event.values[0], maxVal: event.values[1] }
    if (this.parsedKryptomon.length < this.totalResult) {
      this.urlBuilding(true)
    }
    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'second total power', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: event.values[0] + "_" + event.values[1]// input of query/filter)             
    });
  }

  reziseBySecondNumber(event) {
    this.resizeBySecond({
      values: this.rangeSecondValue
    });
  }

  clearFilters() {
    this.loadKryptomon(environment.nftServer + "v1/nfts?first=100&skip=0&sortBy=newest&category=kryptomon&isOnSale=true&section=all", true);
    this.mainPowerFilter = undefined
    this.secondPowerFilter = undefined
    this.lifeStageLabel = "";
    this.priceLabel = ""
    this.specialityLabel = ""
    this.typeLabel = ""
    this.typeLabelSecond = "";
    this.tierFilter = ""
    this.isOnSaleFilter = true;
    this.isOnBreedFilter = false;
    this.searchId = null
    this.showSearchIcon = true;
    this.minValuePrice = null
    this.maxValuePrice = null
    // this.minValueMain = 0;
    // this.maxValueMain = 10000;
    // this.minValueSecond = 0;
    // this.maxValueSecond = 10000;
    this.rangeValue = [0, 10000];
    this.rangeSecondValue = [0, 10000];
    for (let i = 0; i < this.tierArray.length; i++) {
      this.tierArray[i].selected = false
    }
    for (let i = 0; i < this.elementsArrayMain.length; i++) {
      this.elementsArrayMain[i].selected = false
      this.elementsArraySecond[i].selected = false
    }

    for (let i = 0; i < this.lifeStageArray.length; i++) {
      this.specialityArray[i].selected = false;
      this.lifeStageArray[i].selected = false;
    }

  }

  infiniteLoadKryptomon(url) {
    this.loadInfinite = true;
    this.http.get(url).subscribe((item: any) => {
      for (let i = 0; i < item.data.length; i++) {
        let mainTalentName = item.data[i].nft.data.kryptomon.elementType.toLowerCase();
        let secondTalentName = item.data[i].nft.data.kryptomon.elementTypeSecond.toLowerCase();

        //console.log(mainTalentName)
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName])
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName+'Talent'])

        let mainTalentAmount = item.data[i].nft.data.kryptomon.genes[mainTalentName] * item.data[i].nft.data.kryptomon.genes[mainTalentName + 'Talent']
        let secondTalentAmount = item.data[i].nft.data.kryptomon.genes[secondTalentName] * item.data[i].nft.data.kryptomon.genes[secondTalentName + 'Talent']

        item.data[i].nft.data.kryptomon.mainTalentAmount = mainTalentAmount;
        item.data[i].nft.data.kryptomon.secondTalentAmount = secondTalentAmount;

      }
      //console.log('quiqui')
      //console.log(this.parsedSuccess)
      this.parsingIndex = 0;
      this.parseKryptomon(this.parsingIndex, item.data)

    })
  }

  loadKryptomon(url, refresh = false) {
    this.currentIndex = 0;
    this.parsedSuccess = false;
    if (refresh) {
      this.ref.detectChanges()
    }
    this.http.get(url).subscribe((item: any) => {
      //console.log(item)
      this.totalResult = item.total;

      for (let i = 0; i < item.data.length; i++) {
        let mainTalentName = item.data[i].nft.data.kryptomon.elementType.toLowerCase();
        let secondTalentName = item.data[i].nft.data.kryptomon.elementTypeSecond.toLowerCase();

        //console.log(mainTalentName)
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName])
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName+'Talent'])

        let mainTalentAmount = item.data[i].nft.data.kryptomon.genes[mainTalentName] * item.data[i].nft.data.kryptomon.genes[mainTalentName + 'Talent']
        let secondTalentAmount = item.data[i].nft.data.kryptomon.genes[secondTalentName] * item.data[i].nft.data.kryptomon.genes[secondTalentName + 'Talent']

        item.data[i].nft.data.kryptomon.mainTalentAmount = mainTalentAmount;
        item.data[i].nft.data.kryptomon.secondTalentAmount = secondTalentAmount;

        if (this.maxValuePrice !== null && this.maxValuePrice !== undefined && this.maxValuePrice > 0 && this.minValuePrice !== null && this.minValuePrice !== undefined) {
          if (item.data[i].order.priceUSD > this.maxValuePrice || item.data[i].order.priceUSD < this.minValuePrice) {
            item.data.splice(i, 1);
          }
        }

      }


      this.parsedKryptomon = []
      console.log('clean')
      console.log(url)

      this.parsingIndex = 0;

      //console.log('quiqui')
      //console.log(this.parsedSuccess)
      this.parseKryptomon(this.parsingIndex, item.data)

    })
  }

  loadKryptomonAttach(url) {
    this.currentIndex = 0;
    this.parsedSuccess = false;
    this.ref.detectChanges()
    this.http.get(url).subscribe((item: any) => {
      //console.log(item)
      this.totalResult = item.total;

      for (let i = 0; i < item.data.length; i++) {
        let mainTalentName = item.data[i].nft.data.kryptomon.elementType.toLowerCase();
        let secondTalentName = item.data[i].nft.data.kryptomon.elementTypeSecond.toLowerCase();

        //console.log(mainTalentName)
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName])
        //console.log(item.data[i].nft.data.kryptomon.genes[mainTalentName+'Talent'])

        let mainTalentAmount = item.data[i].nft.data.kryptomon.genes[mainTalentName] * item.data[i].nft.data.kryptomon.genes[mainTalentName + 'Talent']
        let secondTalentAmount = item.data[i].nft.data.kryptomon.genes[secondTalentName] * item.data[i].nft.data.kryptomon.genes[secondTalentName + 'Talent']

        item.data[i].nft.data.kryptomon.mainTalentAmount = mainTalentAmount;
        item.data[i].nft.data.kryptomon.secondTalentAmount = secondTalentAmount;

        if (this.maxValuePrice !== null && this.maxValuePrice !== undefined && this.maxValuePrice > 0 && this.minValuePrice !== null && this.minValuePrice !== undefined) {
          if (item.data[i].order.priceUSD > this.maxValuePrice || item.data[i].order.priceUSD < this.minValuePrice) {
            item.data.splice(i, 1);
          }
        }

      }

      this.parsingIndex = 0;

      //console.log('quiqui')
      //console.log(this.parsedSuccess)
      this.parseKryptomon(this.parsingIndex, item.data)

    })
  }


  parseKryptomon(index, response) {
    console.log('parsing')
    //console.log(index)
    console.log(response.length)
    if (index < response.length) {
      let i = index;
      //console.log(i)
      let item = response[i].nft
      console.log(item)
      let id = item.tokenId;
      if (!item.isStarter) {
        item.order = response[i].order
      }
      if(item.data.kryptomon.ranking<650){
              item.tierName = "Rookie"
              item.tierNumber = 1
              if(item.data.kryptomon.ranking<625){
                item.starValue = 1
              }else{
                item.starValue = 1.5
              }
              
            }else if(item.data.kryptomon.ranking>=650 && item.data.kryptomon.ranking<700){
              item.tierName = "Veteran"
              item.tierNumber = 2
              if(item.data.kryptomon.ranking>=650 && item.data.kryptomon.ranking<675){
                item.starValue = 2
              }else{
                item.starValue = 2.5
              }
            }else if(item.data.kryptomon.ranking>=700 && item.data.kryptomon.ranking<775){
              item.tierName = "Elite"
              item.tierNumber = 3
               if(item.data.kryptomon.ranking>=700 && item.data.kryptomon.ranking<725){
                item.starValue = 3
              }else if(item.data.kryptomon.ranking>=725 && item.data.kryptomon.ranking<750){
                item.starValue = 3.5
              }else{
                item.starValue = 4
              }
            }else{
              item.tierName = "Hero"
              item.tierNumber = 4
               if(item.data.kryptomon.ranking>=775 && item.data.kryptomon.ranking<800){
                item.starValue = 4.5
              }else{
                item.starValue = 5
              }
            }

      if (item.data.kryptomon.status > 1 && !item.data.kryptomon.isStarter) {
        if (!item.data.kryptomon.breedingCount) {
          item.breedingDone = 0;
        } else {
          item.breedingDone = item.data.kryptomon.breedingCount;
        }

        if (!item.data.kryptomon.breedingsLeft) {
          item.data.kryptomon.breedingsLeft = 0;
        }

        item.breedingTotal = parseInt(item.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
      }
      if (item.data.kryptomon.status == 0) {

        var imageSelected

        if (item.data.kryptomon.genes.xFactor == 1) {
          imageSelected = "super"
        } else {
          imageSelected = item.data.kryptomon.speciality.toLowerCase()
        }

        if (item.data.kryptomon.unfreezable == 1) {
          item.image = "./assets/img/top_special/" + item.data.kryptomon.elementType + "/" + imageSelected + ".png";
        } else {
          if (item.tokenId == 6188) {
            item.image = "./assets/img/top_special/custom/6188.png";
          } else {
            item.image = "./assets/img/" + item.data.kryptomon.elementType + "/" + imageSelected + ".png";
          }
        }
      } else if (item.data.kryptomon.status == 1) {
        item.image = environment.apiImages+ "images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
      } else if (item.data.kryptomon.status == 2) {
        item.image = environment.apiImages+ "images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
      }


      if (!item.data.kryptomon.name) {
        if (item.data.kryptomon.isStarter) {
          item.name = "S-" + (item.tokenId - 1000000000)
        } else {
          item.name = "#" + item.tokenId
        }

      }
      if (item.data.kryptomon.genes.sex <= 5) {
        item.genderIcon = "./assets/img/Icon/female-icon.svg"
      } else {
        item.genderIcon = "./assets/img/Icon/male-icon.svg"
      }

      item.mainFamilyImage = "./assets/img/icons/" + item.data.kryptomon.elementType.toLowerCase() + ".svg";
      item.secondaryFamilyImage = "./assets/img/icons/" + item.data.kryptomon.elementTypeSecond.toLowerCase() + ".svg";


      this.parsedKryptomon.push({ data: item });

      if (response.length > 1) {
        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)
        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)
        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)
      } else {
        this.sortByPrice(this.selectedPriceSorting)
        this.parsedSuccess = true;


        console.log(this.parsedKryptomon)
        this.ref.detectChanges()
        if (this.loadInfinite) {
          setTimeout(() => {
            console.log(this.posY)
            window.scrollTo(0, this.posY)
          }, 10)
        }
        this.loadInfinite = false;
        if (!this.showSearchIcon) {
          setTimeout(() => {
            console.log('focus')
            console.log(document.querySelectorAll<HTMLInputElement>(".ng2-tag-input__text-input")[0])
            document.querySelectorAll<HTMLInputElement>(".ng2-tag-input__text-input")[0].focus()
          }, 100)
        }
      }

    } else if (index / 3 == response.length) {
      console.log('qua per caso?')
      this.sortByPrice(this.selectedPriceSorting)
      this.parsedSuccess = true;
      this.ref.detectChanges()
      if (this.loadInfinite) {
        setTimeout(() => {
          console.log(this.posY)
          window.scrollTo(0, this.posY)
        }, 10)
      }
      this.loadInfinite = false;
      //console.log(this.parsedKryptomon)
    }
  }


  /*openMarketplace(url){
    this.router.navigate(['/hub/marketplace', url])
  }*/

  openDetails(tokenId) {
    this.router.navigate(['/kryptomons/', tokenId])
  }

  resizeByPrice() {
    if ((this.minValuePrice == undefined || this.minValuePrice == 0) && (this.maxValuePrice == undefined)) {
      this.priceLabel = "";
    } else {
      /*if(this.maxValuePrice==undefined){
        this.maxValuePrice = 1000
      }*/

      if (this.minValuePrice == undefined) {
        this.minValuePrice = 0;
      }

      this.priceLabel = this.web3Service.getWeb3().utils.toWei(this.minValuePrice.toString()) + "_" + this.web3Service.getWeb3().utils.toWei(this.maxValuePrice.toString())
    }

    analytics.track('Filter used', {
      section: 'filter', // toggle, filter, search
      value: 'price', // toggle (breedable, on sale, time, price), filter (rank, price, life stage, speciality, elemental families, total power), search (searchbar)
      input: this.minValuePrice.toString() + "_" + this.maxValuePrice.toString()// input of query/filter)             
    });

    this.urlBuilding(false)
  }


}
